module.exports = __webpack_public_path__ + "static/media/dakar.335f5719.jpg";